import { Component } from '@angular/core';

@Component({
  selector: 'app-roles-layout',
  template: `
    <div class="overview__layout">
      <div class="overview__overview">
        <app-roles></app-roles>
      </div>
      <div class="overview__sidepanel">
        <app-roles-sidepanel></app-roles-sidepanel>
      </div>
    </div>
  `,
})
export class RolesLayoutComponent {}
